export const designType = [
    { value: 'SMALL', name: 'SMALL' },
    { value: 'LARGE', name: 'LARGE' },
    { value: 'BANNER', name: 'BANNER' },
    { value: 'MEDIUM', name: 'MEDIUM' },
    { value: 'VIDEO', name: 'VIDEO' },
    { value: 'SMALL', name: 'SMALL' },
    { value: 'SQUARE', name: 'SQUARE' },
    { value: 'PORTRAIT', name: 'PORTRAIT' },
    { value: 'CIRCLE', name: 'CIRCLE' },
  ]

export const inferanceModelEnum = [
    { value: 'FAL_QWEN_IMAGE_EDIT', name: 'FAL Qwen Image Edit' },
    { value: 'FAL_GEMINI_FLASH_IMAGE_EDIT', name: 'FAL Gemini Flash Image Edit' },
    { value: 'FAL_IDEOGRAM_CHARACTER', name: 'FAL Ideogram Character' },
    { value: 'FAL_GEMINI_FLASH_IMAGE_EDIT_PRO', name: 'FAL Gemini Flash Image Edit Pro' },
  ]